import React from "react";
import '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode, faChartLine, faRobot } from '@fortawesome/free-solid-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "React",
    "JavaScript",
    "HTML5",
    "CSS3",
    "Node.js",
    "Flask",
    "MongoDB",
    "PostgreSQL",
    "SQL",
    "ASP .NET",
    "C#",
    "Rest API",
    "SQL Server",
];

const labelsSecond = [
    "QlikView",
    "Power BI",
    "Tableau",
    "Excel",
    "DAX",
    "Power Query",
    "Pandas",
    "NumPy",
    "ETL",
    "Snowflake",
];

const labelsThird = [
    "OpenAI",
    "LangChain",
    "LLMs",
    "TensorFlow",
    "Keras",
    "Streamlit",
    "Flask",
    "Hugging Face",
];

function Expertise() {
    return (
        <div className="container" id="expertise">
            <div className="skills-container">
                <h1>Expertise</h1>
                <div className="skills-grid">

                    {/* Full Stack Development */}
                    <div className="skill">
                        <FontAwesomeIcon icon={faCode} size="3x"/>
                        <h3>Full Stack Development</h3>
                        <p>Developing robust and scalable **web applications** using modern front-end and back-end technologies, focusing on responsive UI/UX and optimized API integration.</p>
                        <div className="flex-chips">
                            <span className="chip-title">Tech stack:</span>
                            {labelsFirst.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>

                    {/* Business Intelligence & Data Analytics */}
                    <div className="skill">
                        <FontAwesomeIcon icon={faChartLine} size="3x"/>
                        <h3>Business Intelligence & Data Analytics</h3>
                        <p>Expert in **data visualization, dashboard creation, and insights generation** using QlikView, Power BI, and Tableau for effective decision-making.</p>
                        <div className="flex-chips">
                            <span className="chip-title">Tech stack:</span>
                            {labelsSecond.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>

                    {/* AI & Machine Learning */}
                    <div className="skill">
                        <FontAwesomeIcon icon={faRobot} size="3x"/>
                        <h3>AI & Machine Learning</h3>
                        <p>Integrating **LLMs, OpenAI APIs, and NLP models** into applications for intelligent automation, chatbot development, and AI-powered analytics.</p>
                        <div className="flex-chips">
                            <span className="chip-title">Tech stack:</span>
                            {labelsThird.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Expertise;
